import { useCallback, useState } from 'react';
import { useAuth } from '../context/authContext';
import { apiFetchCurrentUserDetails} from '../../api/backend/user';
import { isSuspendedFrom } from '../../utils/membersSiteAccessPermissions';

// passing the currentMemberId id from the remote and then
// passing this call back to the profile page to run the call back on mount
// when the user clicks on the remote profile button we will call the current user's
// data, then we will define the current user as account holder so user can edit
// the profile
export const useCurrentUserAcctDetails = () => {
  const { currentMemberId, handleLogout } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDetailsOnProfileClick = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiFetchCurrentUserDetails(currentMemberId);

      // eject if suspended
      if (isSuspendedFrom(res) || isSuspendedFrom(res?.data)) {
        await handleLogout();
        setError({ code: 'eject' });
        return null;
      }

      return res?.data ?? null;
    } catch (err) {
      // eject if suspended (error path)
      if (isSuspendedFrom(err) || isSuspendedFrom(err?.response)) {
        await handleLogout();
        setError({ code: 'eject' });
        return null;
      }
      console.error('Failed to fetch current user details:', err);
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  }, [currentMemberId, handleLogout]);

  return { loading, error, fetchDetailsOnProfileClick };
};